import { DatabaseCode, toDatabaseCode } from "./database-code";

export type ConnectorType = DatabaseCode;

const email: ConnectorType = {
  code: "EMAIL",
  displayValue: {
    id: "common.entity.connectortype.email",
    defaultMessage: "Email",
  },
};

const ftp: ConnectorType = {
  code: "FTP",
  displayValue: {
    id: "common.entity.connectortype.ftp",
    defaultMessage: "FTP",
  },
};

const sftp: ConnectorType = {
  code: "SFTP",
  displayValue: {
    id: "common.entity.connectortype.sftp",
    defaultMessage: "SFTP",
  },
};

const s3: ConnectorType = {
  code: "S3",
  displayValue: {
    id: "common.entity.connectortype.s3",
    defaultMessage: "S3",
  },
};

const azureBlob: ConnectorType = {
  code: "AZURE_BLOB",
  displayValue: {
    id: "common.entity.connectortype.azureBlob",
    defaultMessage: "Azure Blob Storage",
  },
};

const api: ConnectorType = {
  code: "API",
  displayValue: {
    id: "common.entity.connectortype.api",
    defaultMessage: "API",
  },
};

const local: ConnectorType = {
  code: "LOCAL",
  displayValue: {
    id: "common.entity.connectortype.local",
    defaultMessage: "Local",
  },
};

export const connectorType = {
  email,
  ftp,
  sftp,
  s3,
  azureBlob,
  api,
  local,
};

export const connectorTypes = Object.values(connectorType);

export const toConnectorType = (code: string): ConnectorType =>
  toDatabaseCode(code, connectorTypes);

export const toConnectorTypeSafely = (
  code: string | undefined
): ConnectorType | undefined =>
  code ? toDatabaseCode(code, connectorTypes) : undefined;
